import React from 'react';
import PdfViewer from '../marketing/PdfViewer';

const PDF_URL = 'https://global.divhunt.com/3147c6d061f6aeb8b89ce4e6578e03bf_466097.pdf';

export default function CWColdCallScript() {
  return (
    <PdfViewer
      eyebrow="Cold calling script"
      title="Say it simply. Book the call."
      intro="View the cold calling script here, open it full screen, or download a copy."
      url={PDF_URL}
      frameTitle="CW cold calling script"
    />
  );
}